<template>
  <div>
    <Header />
    <div class="get-started">
      <div class="wrapper container rounded">
        <ul class="StepProgress">
          <li id="1" class="StepProgress-item" v-bind:class="{
            current: currentStep === 1,
            isDone: currentStep > 1,
          }">
            <strong>Choose evidence type</strong>
            <div class="col content-container">
              <transition>
                <TypeSelection v-if="currentStep === 1" :nextHandler="nextHandler" :typeSelectionCB="typeSelectionCB" />
              </transition>
            </div>
            <div class="col short-content-container text-muted">
              <span v-if="evType == 1"> Selected web capture</span>
              <span v-else> Selected local document signing</span>
            </div>
          </li>
          <li id="2" class="StepProgress-item" v-bind:class="{
            current: currentStep === 2,
            isDone: currentStep > 2,
          }">
            <strong>Select content</strong>
            <div class="col content-container">
              <transition>
                <WebCaptureSelection v-if="currentStep === 2 && evType === 1" :nextHandler="nextHandler"
                  :webCapSelectionCB="webCapSelectionCB" />
                <FileSelector v-if="currentStep === 2 && evType === 2" :nextHandler="nextHandler"
                  :fileSelectorCB="fileSelectorCB" />
              </transition>
            </div>
            <div class="col short-content-container text-muted">
              <span v-if="evType == 1"> {{ captureURL }}</span>
              <span v-else> Selected local document signing</span>
            </div>
          </li>
          <li id="3" class="StepProgress-item" v-bind:class="{
            current: currentStep === 3,
            isDone: currentStep > 3,
          }">
            <strong>Preview</strong>
            <div class="col content-container">
              <transition>
                <WebCapture v-if="currentStep === 3 && evType === 1" :captureURL="captureURL" :nextHandler="nextHandler"
                  :webCapCB="webCapCB" />
                <SignFile v-if="currentStep === 3 && evType === 2" :nextHandler="nextHandler"
                  :selectedFile="selectedFile" :signFileCB="signFileCB" />
              </transition>
            </div>
            <div class="col short-content-container text-muted">
              <span> Preview verified by user</span>
            </div>
          </li>
          <li id="4" class="StepProgress-item" v-bind:class="{
            current: currentStep === 4,
            isDone: currentStep > 4,
          }">
            <strong>Payment</strong>
            <div class="col content-container">
              <transition>
                <Payment v-if="currentStep === 4" :nextHandler="nextHandler" :OTUItems="OTUItems" />
              </transition>
            </div>
            <div class="col short-content-container text-muted">
              <span> Payment Complete</span>
            </div>
          </li>
          <li id="5" class="StepProgress-item" v-bind:class="{
            current: currentStep === 5,
            isDone: currentStep > 5,
          }">
            <strong>Finish</strong>
            <div class="col content-container">
              <transition>
                <Finish v-if="currentStep === 5" :OTUItems="OTUItems" />
              </transition>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import WebCapture from "./WebCapture.vue"
import Summary from "./Summary.vue"
import Payment from "./Payment.vue"
import TypeSelection from "./TypeSelection.vue"
import WebCaptureSelection from "./WebCaptureSelection.vue"
import Finish from "./Finish.vue"
import FileSelector from "./FileSelector"
import SignFile from "./SignFile.vue"
import timeout from "../functions/timeout"
import Header from "./Header.vue"
import Footer from "./Footer.vue"

export default {
  name: "GetStartedPaged",
  data() {
    return {
      currentStep: 1,
      evType: null,
      captureURL: null,
      webCapData: null,
      summaryItems: [],
      OTUItems: [],
      selectedFile: null,
    }
  },
  mounted() {
    this.evType = Number(this.$route.query.mode)
    if (this.evType === 1 || this.evType === 2) {
      this.currentStep = 2
    }
  },
  watch: {
    $route(to, from) {
      this.evType = Number(this.$route.query.mode)
      if (this.evType === 1 || this.evType === 2) {
        this.currentStep = 2
      }
      document.getElementById("app").scrollIntoView()
    },
  },
  methods: {
    async getStartedHandler() {
      this.currentStep = 1
      this.scrollToContet(1)
    },
    async nextHandler(id) {
      if (id < 6) {
        this.currentStep = id + 1
        scrollTo(0, 0)
      }
    },
    scrollToContet(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      })
    },
    typeSelectionCB(data) {
      this.evType = data
    },
    webCapSelectionCB(data) {
      this.captureURL = data
    },
    fileSelectorCB(data) {
      this.selectedFile = data
    },
    signFileCB(data) {
      data.map((item, index) => {
        this.summaryItems.push({
          filename: item.filename,
          type: "Local file",
          timestamp: item.timestamp,
        })
        this.OTUItems = []
        this.OTUItems.push({
          id: item.signatureID,
          evType: 2,
          filename: item.filename,
          type: "Local file",
          timestamp: item.timestamp,
        })
      })
    },
    webCapCB(data) {
      this.webCapData = data
      data.map((item, index) => {
        this.summaryItems.push({
          filename: item.metadata.Domain,
          type: "Web Archive",
          timestamp: item.metadata.Timestamp,
        })
        this.OTUItems = []
        this.OTUItems.push({
          id: item.captureID,
          evType: 1,
          filename: item.metadata.Domain,
          type: "Web Archive",
          timestamp: item.metadata.Timestamp,
        })
      })
    },
  },
  components: {
    WebCapture,
    Summary,
    Payment,
    TypeSelection,
    WebCaptureSelection,
    Finish,
    FileSelector,
    SignFile,
    Header,
    Footer,
  },
}
</script>
<style scoped>
.get-started {
  background: var(--background-secondary);
  padding-top: 70px;
  text-align: center;
  padding-bottom: 70px;
}

.wrapper {
  background-color: var(--background-secondary);
  font-size: 14px;
  color: var(--font-color-primary);
}

.StepProgress {
  position: relative;
  list-style: none;
  padding: 0;
}

.StepProgress-item {
  position: relative;
  counter-increment: list;
}

.StepProgress-item::before {
  display: inline-block;
  content: "";
  position: absolute;
  left: -34px;
  height: 100%;
  width: 10px;
}

.StepProgress strong {
  display: none;
}

.StepProgress-item.current strong,
.StepProgress-item.isDone strong {
  display: none;
}

.content-container {
  display: none;
  min-height: 625px;
}

.StepProgress-item.current .content-container {
  display: inherit;
  padding-bottom: 100px;
}

.StepProgress-item:last-child.isDone .content-container {
  display: inherit;
}

.selection-btn {
  color: rgb(92, 92, 92);
  font-weight: 400;
}

.StepProgress-item .short-content-container {
  display: none;
}
</style>
<style>
.steps-button {
  margin-top: 2rem;
}

.back-btn {
  background-color: #c2c2c2;
  font-weight: bold;
  font-size: 13px;
  color: #555;
}

.btn-outline-primary {
  border-color: #10a2e6;
  color: #10a2e6;
}

.btn-outline-primary:hover {
  border-color: #10a2e6;
  background-color: #10a2e6;
}

.next-btn {
  background: var(--primary-green);
  color: white;
  font-weight: bold;
  font-size: 13px;
}

.next-btn:hover {
  filter: brightness(110%) saturate(110%);
  color: white;
  background: var(--primary-green);
}

.next-btn:disabled:hover {
  background: var(--primary-green);
}

.text-blue {
  color: #10a2e6;
}

.alert-info {
  color: #fff;
  border: 1px solid #10a2e6;
  background-color: #10a2e6;
  padding: 8px 10px;
  border-radius: 5px;
  font-weight: 500;
}

.danger-info {
  color: #fff;
  border: 1px solid #eb4e4e;
  background-color: #f14c4c;
  padding: 8px 10px;
  border-radius: 5px;
  font-weight: 500;
}

.success-info {
  color: #fff;
  border: 1px solid #00c781;
  background-color: #00c781;
  padding: 8px 10px;
  border-radius: 5px;
  font-weight: 500;
}

.v-enter-active {
  animation: bounceIn 0.5s;
}

.v-leave {
  animation: bounceIn 1s reverse;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: translateX(-10%);
  }

  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}

@keyframes glow {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GetStartedPaged.vue